import "./index.sass";

export interface BtnProps {
  id?: number;
  icon?: React.ReactNode;
  label: string;
  color: "purple" | "blue" | "orange" | "darkOrange" | "red";
  active?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const Btn = ({
  label,
  icon,
  color,
  active = false,
  onClick,
  style = {},
}: BtnProps) => {
  return (
    <div
      className={`csp-btn ${active ? `${color}-active` : ""}`}
      style={style}
      onClick={onClick}
    >
      {icon && icon}
      <div>{label}</div>
    </div>
  );
};

export default Btn;
